import React from "react";
import PropTypes from "prop-types";
// Material imports
import TextField from "@mui/material/TextField";
// Limitless imports
import Grid from "../../layout/Grid";
import makeStyles from "@mui/styles/makeStyles";
const isNumeric = valInString => !isNaN(parseInt(valInString, 10));
const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  }
}));
const CodeCollector = ({
  max = 6,
  onUpdate,
  clearAll = false,
  onError,
  isRecontactConfig = false,
  disabled = false,
  ...rest
}) => {
  const codeArr = [...Array(max).fill("")];
  const [codes, setCodes] = React.useState(codeArr);
  const refs = React.useRef(new Array(max));
  const classes = useStyles();
  React.useEffect(() => {
    if (clearAll === true) {
      setCodes(codeArr);
    }
  }, [clearAll]);
  const handleUpdateCode = (num, i) => {
    const newCodes = [...codes];
    newCodes[i] = num;
    setCodes(newCodes);
    if (typeof onUpdate === "function") {
      onUpdate(newCodes.join(""));
    }
  };
  const handleKeyDown = (e, i) => {
    if (e.keyCode === 8) {
      handleUpdateCode("", i);
      if (refs.current[i - 1]) {
        refs.current[i - 1].focus();
      }
    }
  };
  const handleChange = (e, i) => {
    var _e$target;
    if (!isNumeric(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value)) {
      return;
    }
    handleUpdateCode(e.target.value, i);
    if (refs.current[i + 1]) {
      refs.current[i + 1].focus();
    }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 1.5,
    className: isRecontactConfig ? classes.container : ""
  }, codeArr.map((v, i) => {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      key: i
    }, /*#__PURE__*/React.createElement(TextField, {
      inputProps: {
        maxLength: 1,
        sx: {
          textAlign: "center",
          fontWeight: 500,
          lineHeight: "21px",
          padding: 0
        }
      },
      inputRef: ele => refs.current[i] = ele,
      onKeyDown: e => handleKeyDown(e, i),
      onChange: e => handleChange(e, i),
      value: codes[i],
      id: `${rest.id}-${i}`,
      autoFocus: i === 0,
      placeholder: "",
      disabled: disabled,
      InputProps: {
        sx: {
          height: 56,
          width: 48,
          padding: "17px 19.5px",
          marginTop: 0,
          borderRadius: "8px",
          ...(onError && {
            border: "1px solid #AD0026",
            padding: "0px 0px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none"
            }
          })
        }
      }
    }));
  }));
};
CodeCollector.propTypes = {
  max: PropTypes.number,
  clearAll: PropTypes.bool,
  onUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  onError: PropTypes.bool,
  isRecontactConfig: PropTypes.bool
};
export default CodeCollector;